import { render, staticRenderFns } from "./GSelect.vue?vue&type=template&id=bd69f63e"
import script from "./GSelect.vue?vue&type=script&lang=js"
export * from "./GSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports